function isAbroad() {
  return [
    "us.home.mi.com",
    "i2.home.mi.com",
    "sg.home.mi.com",
    "de.home.mi.com",
    "ru.home.mi.com",
  ].includes(window.location.host)
}
/**
 * 设置 Cookie
 * @example
 * setCookie("_onetrack_cid", localStorage.get("_onetrack_cid"))
 * @param name Cookie name
 * @param value Cookie value
 * @param days expire days
 */
function setCookie(name, value = '', days) {
  let expires = ''
  if (days) {
    const date = new Date()
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
    expires = `; expires=${date.toUTCString()}`
  }
  document.cookie = `${name}=${value || ''}${expires}; path=/`
}

/**
 * 曝光打点方法
 * @param {string} model 产品 Model
 * @param {number | string} model 产品 id
 * @param {string} qrType  二维码类型
 * @param {number | string} type 扫码渠道
 * @param {*} eventType
 * @returns
 */
export default function expose(model, pdid, qrType, type, eventType) {
  if (isAbroad()) {
    return
  }
  window.onetrack("track", "expose", {
    dmodel: model,
    card_id: pdid,
    view_type: qrType,
    type,
    event_type: eventType
  })
}

export function injectOneTrack(onReady, onError) {
  if (isAbroad()) {
    onReady()
    return
  }
  // 接入 OneTrack平台 打点
  window.onetrack = window.onetrack || function () {
    // eslint-disable-next-line prefer-rest-params
    (window.onetrack.q = window.onetrack.q || []).push(arguments)
  }
  window.onetrack("init", "2882303761517233197") // 米家
  const oneTrackScript = document.createElement('script')
  oneTrackScript.src = '//ssl-cdn.static.browser.mi-img.com/mistat-data/onetrack/onetrack.js'
  oneTrackScript.onload = function() {
    setCookie("_onetrack_cid", localStorage.getItem('_onetrack_cid'))
    onReady()
  }
  oneTrackScript.onerror = onError
  document.head.appendChild(oneTrackScript)
}



// WEBPACK FOOTER //
// ./src/utils/track.js